import { ParametroHeaderService } from "../service/parametroHeader.service";  
import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class logosBase64 {

  private logosEsquerdaSubject = new BehaviorSubject<any[]>([]);
  private logosDireitaSubject = new BehaviorSubject<any[]>([]);

  logosEsquerda$ = this.logosEsquerdaSubject.asObservable();
  logosDireita$ = this.logosDireitaSubject.asObservable();

  private carregado = false;

  constructor(private parametroHeaderService: ParametroHeaderService) {}

  carregarLogos() {
    //if (this.carregado) return;

    this.carregado = true;

    // ESQUERDA
    this.parametroHeaderService
      .buscarListaParametrosHeaderAtivosTipo("Relatorio_Esquerda")
      .subscribe((result) => {
        console.log(result);
        const lista = result["Parametro_Header"] || [];

        const formatado = lista.map((el: { foto: any; width: any; }) => ({
          image: `data:image/png;base64,${el.foto}`,
          width: el.width || 100,
          alignment: 'left',
          margin: [0, 0, 10, 0]
        }));

        this.logosEsquerdaSubject.next(formatado);

      });

    // DIREITA
    this.parametroHeaderService
      .buscarListaParametrosHeaderAtivosTipo("Relatorio_Direita")
      .subscribe((result) => {
        console.log(result);

        const lista = result["Parametro_Header"] || [];

        const formatado = lista.map((el: { foto: any; width: any; }) => ({
          image: `data:image/png;base64,${el.foto}`,
          width: el.width || 60
        }));

        this.logosDireitaSubject.next(formatado);

      });
  }
}
